export const genderList = [
  {
    id: 'male',
    name: 'Male'
  },
  {
    id: 'female',
    name: 'Female'
  }
]

export const nationalityList = [
  {
    id: 'indian',
    name: 'Indian'
  },
  {
    id: 'saudi',
    name: 'Saudi'
  },
  {
    id: 'others',
    name: 'Others'
  }
]

export const studentTypeList = [
  {
    id: 'karnataka',
    name: 'Karnataka'
  },
  {
    id: 'non-karnataka',
    name: 'Non Karnataka'
  },
  {
    id: 'nri',
    name: 'NRI'
  }
]

export const checkBoxDropdownList = [
  {
    id: 'yes',
    name: 'Yes'
  },
  {
    id: 'no',
    name: 'No'
  }
]

export const casteList = [
  {
    id: 'adiDravida',
    name: 'Adi Dravida'
  },
  {
    id: 'adiKarnataka',
    name: 'Adi Karnataka'
  },
  {
    id: 'brahmin',
    name: 'Brahmin'
  },
  {
    id: 'Devanagar',
    name: 'Devanagar'
  },
  {
    id: 'Dhobi',
    name: 'Dhobi'
  },
  {
    id: 'Gowdas',
    name: 'Gowdas'
  },
  {
    id: 'Iyengar',
    name: 'Iyengar'
  },
  {
    id: 'Jain communities',
    name: 'Jain communities'
  },
  {
    id: 'Kurubas',
    name: 'Kurubas'
  },
  {
    id: 'Lingayats',
    name: 'Lingayats'
  },
  {
    id: 'Nadar',
    name: 'Nadar'
  },
  {
    id: 'Others',
    name: 'Others'
  },
  {
    id: 'Reddy',
    name: 'Reddy'
  },
  {
    id: 'Udaiyar',
    name: 'Udaiyar'
  },
  {
    id: 'Vanniar',
    name: 'Vanniar'
  },
  {
    id: 'Vokkaligas',
    name: 'Vokkaligas'
  },
  {
    id: 'Yadavar',
    name: 'Yadavar'
  },

]

export const religionList = [
  {
    id: 'hindu',
    name: 'Hindu'
  },
  {
    id: 'muslim',
    name: 'Muslim'
  },
  {
    id: 'chirstian',
    name: 'Chirstian'
  }
]

export const categoryList = [
  {
    id: 'cat1',
    name: 'Cat I'
  },
  {
    id: 'cat2',
    name: 'Cat II'
  },
  {
    id: 'gm',
    name: 'GM'
  },
  {
    id: 'a2',
    name: 'II A'
  },
  {
    id: 'b2',
    name: 'II B'
  },
  {
    id: 'a3',
    name: 'III A'
  },
  {
    id: 'b3',
    name: 'III B'
  },
  {
    id: 'obc',
    name: 'OBC'
  },
  {
    id: 'others',
    name: 'Others'
  },
  {
    id: 'sc',
    name: 'SC'
  },
  {
    id: 'sikh',
    name: 'SIKH'
  },
  {
    id: 'st',
    name: 'ST'
  }
]

export const countryList = [
  {
    id: 'india',
    name: 'India'
  },
  {
    id: 'us',
    name: 'U.S'
  },
  {
    id: 'others',
    name: 'Others'
  }
]

export const stateList = [
  {
    id: 'andraPradesh',
    name: 'Andhra Pradesh'
  },
  {
    id: 'arunachalPradesh',
    name: 'Arunachal Pradesh'
  },
  {
    id: 'assam',
    name: 'Assam'
  },
  {
    id: 'bihar',
    name: 'Bihar'
  },
  {
    id: 'chhattisgarh',
    name: 'Chhattisgarh'
  },
  {
    id: 'goa',
    name: 'Goa'
  },
  {
    id: 'gujarat',
    name: 'Gujarat'
  },
  {
    id: 'haryana',
    name: 'Haryana'
  },
  {
    id: 'himachalPradesh',
    name: 'Himachal Pradesh'
  },
  {
    id: 'jammuKashmir',
    name: 'Jammu & Kashmir'
  },
  {
    id: 'jharkhand',
    name: 'Jharkhand'
  },
  {
    id: 'karnataka',
    name: 'Karnataka'
  },
  {
    id: 'kerala',
    name: 'Kerala'
  },
  {
    id: 'madhyaPradesh',
    name: 'Madhya Pradesh'
  },
  {
    id: 'maharashtra',
    name: 'Maharashtra'
  },
  {
    id: 'manipur',
    name: 'Manipur'
  },
  {
    id: 'meghalaya',
    name: 'Meghalaya'
  },
  {
    id: 'mizoram',
    name: 'Mizoram'
  },
  {
    id: 'nagaland',
    name: 'Nagaland'
  },
  {
    id: 'orissa',
    name: 'Orissa'
  },
  {
    id: 'punjab',
    name: 'Punjab'
  },
  {
    id: 'rajasthan',
    name: 'Rajasthan'
  },
  {
    id: 'sikkim',
    name: 'Sikkim'
  },
  {
    id: 'tamilNadu',
    name: 'Tamil Nadu'
  },
  {
    id: 'telangana',
    name: 'Telangana'
  },
  {
    id: 'tripura',
    name: 'Tripura'
  },
  {
    id: 'uttarPradesh',
    name: 'Uttar Pradesh'
  },
  {
    id: 'uttarakhand',
    name: 'Uttarakhand'
  },
  {
    id: 'westBengal',
    name: 'West Bengal'
  }
]

export const mediumList = [
  {
    id: 'english',
    name: 'English'
  },
  {
    id: 'kannada',
    name: 'Kannada'
  }
]

export const boardList = [
  {
    id: 'karanataka',
    name: 'Karnataka Board'
  },
  {
    id: 'cbse',
    name: 'CBSE'
  },
  {
    id: 'icse',
    name: 'ICSE'
  },
  {
    id: 'igcsc',
    name: 'IGCSC'
  },
  {
    id: 'other',
    name: 'OTHER STATE BOARD'
  }
]

export const admissionTypeList = [
  {
    id: 'dayscholar',
    name: 'Dayscholar'
  },
  {
    id: 'sharingType1',
    name: '2 sharing'
  },
  {
    id: 'sharingType2',
    name: '4 sharing'
  },
  {
    id: 'sharingType3',
    name: '6 sharing'
  },
  {
    id: 'dometry',
    name: 'Dometry'
  }
]

export const primaryLanguageList = [
  {
    id: 'english',
    name: 'English'
  }
]

export const secondaryLanguageList = [
  {
    id: 'kannada',
    name: 'Kannada'
  },
  {
    id: 'hindi',
    name: 'Hindi'
  },
  {
    id: 'urdu',
    name: 'Urdu'
  },
  {
    id: 'arabic',
    name: 'Arabic'
  },
  {
    id: 'malayalam',
    name: 'Malayalam'
  },
  {
    id: 'tamil',
    name: 'Tamil'
  }
]

export const statusList = [
  {
    id: '01',
    name: 'ACTIVE'
  },
  {
    id: '02',
    name: 'INACTIVE'
  }
]

export const academicYearList = [
  {
    id: '2019',
    name: '2019-2020'
  },
  {
    id: '2020',
    name: '2010-2021'
  },
  {
    id: '2021',
    name: '2021-2022'
  },
  {
    id: '2022',
    name: '2022-2023'
  },
  {
    id: '2023',
    name: '2023-2024'
  },
  {
    id: '2024',
    name: '2024-2025'
  },
  {
    id: '2025',
    name: '2025-2026'
  }
]
